/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import * as React from 'react';
import moment from 'moment';
import { FormFeedback, FormGroup, FormText, Input, Label } from 'reactstrap';

interface DateTimeEditProps {
    date: Date;
    onChange: (d: Date) => void;
}

interface DateTimeEditState {
    date: string;
    errorMessage: string;
}

const DATETIME_FORMAT = 'DD.MM.YYYY HH:mm';

export class DateTimeEdit extends React.Component<DateTimeEditProps, DateTimeEditState> {

    constructor(props: DateTimeEditProps) {
        super(props);

        this.state = {
            date: moment(this.props.date).format(DATETIME_FORMAT),
            errorMessage: ''
        };

        this.handleSearchChange = this.handleSearchChange.bind(this);
    }

    handleSearchChange(event: React.FormEvent<HTMLInputElement>) {
        let mom = moment(event.currentTarget.value, DATETIME_FORMAT, true);
        if (mom.isValid()) {
            let date: Date = mom.toDate();
            this.setState({date: mom.format(DATETIME_FORMAT), errorMessage: ''},
                          () => this.props.onChange(date));
        } else {
            this.setState({date: event.currentTarget.value, errorMessage: 'ungültiges Datum'});
        }
    }

    getValidationState() {
        return moment(this.state.date, DATETIME_FORMAT, true).isValid();
    }

    render() {
        return (
            <div className="container">
                <form >
                    <FormGroup
                        id="dateTimeEdit"
                    >
                        <Label>Datum:</Label>
                        <Input
                            type="text"
                            value={this.state.date}
                            onChange={this.handleSearchChange}
                            valid={this.getValidationState()}
                        />
                        <FormFeedback/>
                        <FormText>Format: dd.mm.jjjj SS:mm</FormText>

                    </FormGroup>
                </form>
            </div>
        );
    }

}
